module.exports = __webpack_public_path__ + "static/img/sticker_swimming.fa764f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sticker_swimming.jpg
// module id = XyT2
// module chunks = 1